export default "__VITE_ASSET__DAdQGNxk__"